import { navigate, routes } from '@redwoodjs/router'

export const redirectToItList = (id: number, flashError: string) => {
  navigate(
    routes.itListCanonical({
      id,
      flashError,
    })
  )
}
